module.exports = __webpack_public_path__ + "img/myguard_about_07.3f8b536e.png";